import React from 'react';
import { Accordion } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/accordion.less';

export default Accordion;
